import moment from "moment-timezone";
import "./jquery-global";
import "jquery-countdown";
// break this up into more class functions
export default class Countdown {
  constructor(startDate) {
    var previousDate = [];

    var convertedDate = moment
      .tz(startDate, moment.tz.guess())
      .format("YYYY/MM/DD HH:mm:ss");

    $("#countdown-section").countdown(convertedDate, function (event) {
      var currentDate = event.strftime("%D:%-H:%-M:%-S").split(":");

      if (previousDate.length <= 0) {
        currentDate.map(function (item) {
          previousDate.push(item);
        });

        initialMarkup.call(this);
      }

      if (previousDate[0] !== currentDate[0]) {
        previousDate[0] = currentDate[0];
        $(this).find(".days-val").text(event.strftime("%D"));
        $(this).find(".days-text").text(event.strftime("Day%D"));
      }

      if (previousDate[1] !== currentDate[1]) {
        previousDate[1] = currentDate[1];
        $(this).find(".hours-val").text(event.strftime("%-H"));
        $(this).find(".hours-text").text(event.strftime("Hour%!H"));
      }

      if (previousDate[2] !== currentDate[2]) {
        previousDate[2] = currentDate[2];
        $(this).find(".minutes-val").text(event.strftime("%-M"));
        $(this).find(".minutes-text").text(event.strftime("Minute%!M"));
      }

      if (previousDate[3] !== currentDate[3]) {
        previousDate[3] = currentDate[3];
        $(this).find(".seconds-val").text(event.strftime("%-S"));
        $(this).find(".seconds-text").text(event.strftime("Second%!S"));
      }

      function initialMarkup() {
        $(this).find(".days-val").text(event.strftime("%D"));
        $(this).find(".days-text").text(event.strftime("Day%!D"));
        $(this).find(".hours-val").text(event.strftime("%-H"));
        $(this).find(".hours-text").text(event.strftime("Hour%!H"));
        $(this).find(".minutes-val").text(event.strftime("%-M"));
        $(this).find(".minutes-text").text(event.strftime("Minute%!M"));
        $(this).find(".seconds-val").text(event.strftime("%-S"));
        $(this).find(".seconds-text").text(event.strftime("Second%!S"));
      }
    });
  }
}
